import * as React from "react";
const SvgFiRrFingerprint = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fingerprint_svg__a)">
      <path
        fill="#062147"
        d="M5.972 22.285a1 1 0 0 1-.515-1.857C9 18.3 9 13.73 9 11a3 3 0 1 1 6 0 1 1 0 0 1-2 0 1 1 0 0 0-2 0c0 2.947 0 8.434-4.514 11.143a1 1 0 0 1-.514.142m4.963 1.421c2.282-2.3 3.615-5.534 3.961-9.62A1 1 0 0 0 13.985 13a.98.98 0 0 0-1.081.911c-.311 3.657-1.419 6.4-3.388 8.381a1 1 0 1 0 1.419 1.41zm5.2-.186a18 18 0 0 0 1.508-3.18 1 1 0 0 0-1.881-.679c-.352.982-.8 1.927-1.338 2.821a1 1 0 1 0 1.711 1.038m2.365-6.329c.37-2.042.538-4.116.5-6.19A7 7 0 0 0 6.787 6.332a1 1 0 1 0 1.489 1.334A5 5 0 0 1 17 11a29.7 29.7 0 0 1-.462 5.81 1 1 0 0 0 1.962.381M7 11.001q0-.42.069-.834A1 1 0 1 0 5.1 9.833Q5 10.413 5 11c0 4.645-1.346 7-4 7a1 1 0 1 0 0 2c3.869 0 6-3.2 6-9m13.7 12.413A29.8 29.8 0 0 0 23 11a10.9 10.9 0 0 0-1.1-4.794 1.001 1.001 0 0 0-1.8.875 8.9 8.9 0 0 1 .9 3.92 27.9 27.9 0 0 1-2.119 11.585 1 1 0 0 0 1.819.828M3 14v-3a9.01 9.01 0 0 1 9-9 8.9 8.9 0 0 1 5.4 1.8 1 1 0 0 0 1.2-1.6A10.9 10.9 0 0 0 12 0 11.013 11.013 0 0 0 1 11v3a1 1 0 0 0 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fingerprint_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFingerprint;
